import React from "react";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import InputLabel from "@material-ui/core/InputLabel";
// core components
import GridItem from "../../views/Grid/GridItem.js";
import GridContainer from "../../views/Grid/GridContainer.js";
import CustomInput from "../../views/CustomInput/CustomInput.js";
import Button from "../../views/CustomButtons/Button.js";
import Card from "../../views/Card/Card.js";
import CardHeader from "../../views/Card/CardHeader.js";
import CardAvatar from "../../views/Card/CardAvatar.js";
import CardBody from "../../views/Card/CardBody.js";
import CardFooter from "../../views/Card/CardFooter.js";

import avatar from "../../assets/img/faces/marc.jpg";
import { connect } from "react-redux";
import { setUser } from "../../containers/app/actions";
import { Avatar } from "@material-ui/core";

const styles = {
  cardCategoryWhite: {
    color: "rgba(255,255,255,.62)",
    margin: "0",
    fontSize: "14px",
    marginTop: "0",
    marginBottom: "0",
  },
  cardTitleWhite: {
    color: "#FFFFFF",
    marginTop: "0px",
    minHeight: "auto",
    fontWeight: "300",
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    marginBottom: "3px",
    textDecoration: "none",
  },
  avatar: {
    width: 60,
    height: 60,
    background: "#8e24aa",
    color: "white",
  },
};

const useStyles = makeStyles(styles);

const UserProfile = (props) => {
  const classes = useStyles();
  const subChar = props.user && props.user.userName.substring(0, 1);
  return (
    <div>
      <GridContainer>
        <GridItem xs={12} sm={12} md={12}>
          <Card>
            <CardHeader>
              <div>
                <h3>User Profile</h3>
              </div>
            </CardHeader>
          </Card>
        </GridItem>
        <GridItem xs={12} sm={12} md={8}>
          <Card>
            <CardHeader color="primary">
              <h4 className={classes.cardTitleWhite}>View Profile</h4>
            </CardHeader>
            <CardBody>
              <GridContainer>
                <GridItem xs={12} sm={12} md={6}>
                  <CustomInput
                    labelText="Username"
                    id="username"
                    formControlProps={{
                      fullWidth: true,
                    }}
                    value={props.user.userName}
                  />
                </GridItem>
                <GridItem xs={12} sm={12} md={6}>
                  <CustomInput
                    labelText="Email address"
                    id="email-address"
                    formControlProps={{
                      fullWidth: true,
                    }}
                    value={props.user.email}
                  />
                </GridItem>
              </GridContainer>
              <GridContainer>
                <GridItem xs={12} sm={12} md={6}>
                  <CustomInput
                    labelText="User Type"
                    id="user-type"
                    formControlProps={{
                      fullWidth: true,
                    }}
                    value={props.user.userType}
                  />
                </GridItem>
                <GridItem xs={12} sm={12} md={6}>
                  <CustomInput
                    labelText="Contact"
                    id="contact"
                    formControlProps={{
                      fullWidth: true,
                    }}
                    value={props.user.contactNum}
                  />
                </GridItem>
              </GridContainer>
              <GridContainer>
                <GridItem xs={12} sm={12} md={12}>
                  <CustomInput
                    labelText="Address"
                    id="about-me"
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
                      multiline: true,
                      rows: 5,
                    }}
                    value={props.user.userAddress}
                  />
                </GridItem>
              </GridContainer>
            </CardBody>
          </Card>
        </GridItem>
        <GridItem xs={12} sm={12} md={4}>
          <Card profile>
            <CardAvatar profile>
              <Avatar className={classes.avatar}>{subChar}</Avatar>
            </CardAvatar>
            <CardBody profile>
              <h3 className={classes.cardCategory}>{props.user.userType}</h3>
              <h4 className={classes.cardTitle}>{props.user.userName}</h4>

              <Button
                color="primary"
                round
                onClick={() => {
                  props.setUser(false);
                  localStorage.clear();
                }}
              >
                Logout
              </Button>
            </CardBody>
          </Card>
        </GridItem>
      </GridContainer>
    </div>
  );
};
// const checker = (props) => {
//   return { usertype: props.user.userType };

//   // return usertype;
// };

const mapStateToProps = (state) => ({
  user: state.appReducer.user,
});
export default connect(mapStateToProps, { setUser })(UserProfile);
